import { render, staticRenderFns } from "./UnitTypeTable.vue?vue&type=template&id=1d0ff2bc&"
import script from "./UnitTypeTable.vue?vue&type=script&lang=js&"
export * from "./UnitTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports